import React, {  useRef, useState,  useEffect} from "react"
import { useIntersection } from './intersectionObserver'
import classnames from 'classnames';
import blurimg from '../../assets/images/blurimg.jpg'

const ImageComponent = React.memo((props) => {
    const {imageShadowHide} = {...props}
    const [isInView, setIsInView] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false);
    const imgRef = useRef()

    useIntersection(imgRef, () => {
        setIsInView(true)
    })

    const handleOnLoad = () => {
        setIsLoaded(true)
    }
    try {
        return (
            <div className={`image-container ${imageShadowHide ? "shadow-none" : ""} ${props.class} ${isLoaded ? "" : "lazy-img text-gray-300"}`} ref={imgRef}>
                {
                    isInView && (
                        <>
                            <img
                                className={`${imageShadowHide ? "" :"shadow-img"} ${classnames('image', `${props.imgClass ? props.imgClass : ''}`,'thumb', {
                                    ['isLoaded']: !!isLoaded
                                })}`}
                                src={blurimg}
                                alt={props.alt}
                                id={props.id}
                                title={props.title}
                            />
                            <img
                                className={`${imageShadowHide ? "" :"shadow-img"} ${classnames('image', `${props.imgClass ? props.imgClass : ''}`, {
                                    ['isLoaded']: !!isLoaded
                                })}`}
                                src={props.url}
                                onLoad={handleOnLoad}
                                alt={props.alt}
                                id={props.id}
                                title={props.title}
                            />
                        </>
                    )
                }
            </div>
        )
    } catch (e) {
      console.log(e)
      return <></>
    }
})


export default React.memo(ImageComponent)


